import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TSegmentLink } from './models';

export const SegmentLink: FC<TSegmentLink> = props => {
    const { BannerLink, link, onClick, selected, styles, title } = props;

    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <span className={cn(styles.topRow)} onClick={onClick}>
            <BannerLink link={link} selected={selected} title={title}>
                {title}
            </BannerLink>
        </span>
    );
};
